module.exports = __webpack_public_path__ + "img/P150T_weapon_3.24c956eb.png";